import {Divider, Stack, Typography} from "@mui/joy"
import {createFileRoute} from "@tanstack/react-router";
import {useTranslation} from "react-i18next";
import {TileSpread} from "../../../components/Tile.tsx";
import {Bundle} from "../../../rpc/webrpc-client.gen.ts";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";

// CURRENTLY BROKEN

function AdminSanyuJob() {
    const {t} = useTranslation();
    // const {data: allActiveBundlesData, isSuccess}
    //     = useRefreshableQuery(watchBundlesForDispatchTqo);
    const allActiveBundles: Bundle[] = [];

    // if (!isSuccess || !allActiveBundles) {
    //     return <SuspenseDialog message="sanyu"/>;
    // }
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <Stack direction="column" spacing={2}>
                <Divider>
                    <Typography level="h3" color="primary">{t("navi.admin.sanyuJobs")}</Typography>
                </Divider>
                <TileSpread foods={allActiveBundles} estimatedHeight={0} Component={() => null}/>
            </Stack>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/admin/sanyu-job")({
    component: AdminSanyuJob,
});
